import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'

import ja from "./i18n/ja_JP";
import en from "./i18n/en_US";
import kr from "./i18n/kr_KR";

const i18n = createI18n({
  locale: 'ja_JP',
  messages: {
    ja_JP: ja,
    en_US: en,
    kr_KR: kr
  }
})

createApp(App).use(router).use(i18n).mount('#app')
